export enum UsFilingType {
  US_TYPE86_ENTRY = 'US_TYPE86_ENTRY',
  US_CONSUMPTION_ENTRY = 'US_CONSUMPTION_ENTRY',
}
